import { z } from "zod";

export const ReviewPolicySchema = z.enum(["manual", "exceptions"]);
export const QualityFindingSchema = z.strictObject({
  id: z.string(),
  code: z.string(),
  blockIndices: z.array(z.int().nonnegative()),
  nodeIds: z.array(z.string()),
  explanation: z.string(),
  technical: z.boolean(),
  accepted: z.boolean(),
});
export type QualityFinding = z.infer<typeof QualityFindingSchema>;
export const QualityReviewSchema = z.strictObject({
  id: z.uuid(),
  chapterId: z.uuid(),
  versionId: z.uuid(),
  styleSheetVersionId: z.uuid(),
  contentHash: z.string(),
  status: z.enum(["queued", "checking", "repairing", "passed", "attention", "failed", "stale"]),
  findings: z.array(QualityFindingSchema),
  repairAttempted: z.boolean(),
  updatedAt: z.string(),
});
export type QualityReview = z.infer<typeof QualityReviewSchema>;
export const QualityResolutionSchema = z.strictObject({
  reviewId: z.uuid(),
  findingId: z.string(),
});
